import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("template", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vueper_slide = _resolveComponent("vueper-slide")
  const _component_vueper_slides = _resolveComponent("vueper-slides")

  return (_openBlock(), _createBlock(_component_vueper_slides, {
    class: "no-shadow",
    "visible-slides": 1,
    "slide-ratio": 1 / 3,
    "dragging-distance": 90,
    fade: _ctx.carouselStyle.fade,
    arrows: _ctx.carouselStyle.arrows,
    bullets: _ctx.bullets,
    autoplay: false,
    bulletsOutside: "true"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock(_component_vueper_slide, {
          class: "carousel-item",
          key: index,
          image: item.imageSrc,
          link: item.url,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 2
        }, 1032, ["image", "link"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["fade", "arrows", "bullets"]))
}